<google-chart [type]="chartType" [data]="myData" [options]="options" [style]="cStyle" (select)="OnSelect($event)"></google-chart>
